import { useInView } from "react-intersection-observer";

const benefits = [
	"DP langsung penunjukan sapi dengan kontrak yang jelas dan aman",
	"Pembayaran fleksibel — harga lebih hemat dibanding beli dadakan",
	"Garansi kesehatan dan kematian sapi selama masa tabungan",
	"Garansi bobot timbang real dan transparan",
	"Laporan rutin & pemantauan pertumbuhan sapi setiap bulan",
	"Free ongkir hingga lokasi penyembelihan",
	"Kesempatan berhadiah umroh 🕋",
];

export default function TabunganQurban() {
	const { ref: leftRef, inView: leftIn } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});
	const { ref: rightRef, inView: rightIn } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	return (
		<section id="qurban" style={styles.section}>
			<div className="grid-2col-qurban" style={styles.wrap}>
				<div
					ref={leftRef}
					style={{
						...styles.left,
						opacity: leftIn ? 1 : 0,
						transform: leftIn ? "translateY(0)" : "translateY(28px)",
						transition: "all 0.65s",
					}}>
					<div style={{ marginBottom: "1rem" }}>
						<span style={styles.lbl}>Tabungan Qurban</span>
					</div>
					<h2 style={styles.h2}>
						Qurban Lebih Mudah,
						<br />
						Terjangkau &amp; Terjamin
					</h2>
					<p style={styles.desc}>
						Program tabungan qurban NusaQu memberikan kemudahan berqurban dengan
						cicilan fleksibel dan jaminan kualitas hewan yang transparan.
					</p>
					<div style={styles.list}>
						{benefits.map((b, i) => (
							<div key={i} style={styles.item}>
								<div style={styles.chk}>✓</div>
								<span>{b}</span>
							</div>
						))}
					</div>
					<a
						href="https://nusaqu.id/tabungan"
						target="_blank"
						rel="noreferrer"
						style={styles.btn}>
						Daftar Tabungan Qurban →
					</a>
				</div>

				<div
					ref={rightRef}
					style={{
						opacity: rightIn ? 1 : 0,
						transform: rightIn ? "translateY(0)" : "translateY(28px)",
						transition: "all 0.65s 0.15s",
					}}>
					<p style={styles.targetLabel}>Target Penjualan Qurban 2026</p>
					<div className="grid-targets" style={styles.targets}>
						{/* Sapi — coklat bg, angka kuning */}
						<div style={styles.targetSapi}>
							<div style={styles.targetEmoji}>🐄</div>
							<div style={styles.targetNumSapi}>2000</div>
							<div style={styles.targetUnit}>Ekor</div>
							<div style={styles.targetTypeSapi}>Sapi</div>
						</div>
						{/* Domba — kuning bg, angka coklat */}
						<div style={styles.targetDomba}>
							<div style={styles.targetEmoji}>🐑</div>
							<div style={styles.targetNumDomba}>500</div>
							<div style={styles.targetUnit}>Ekor</div>
							<div style={styles.targetTypeDomba}>Domba / Kambing</div>
						</div>
					</div>
					<div style={styles.links}>
						<div style={styles.linksTitle}>Pantau &amp; Daftar</div>
						{[
							{
								icon: "🌐",
								label: "nusaqu.id/tabungan",
								href: "https://nusaqu.id/tabungan",
							},
							{
								icon: "📱",
								label: "app.nusaqu.id/auth/daftar_reseller",
								href: "https://app.nusaqu.id/auth/daftar_reseller",
							},
							{
								icon: "🐄",
								label: "solusiqurban.com",
								href: "https://solusiqurban.com",
							},
						].map((l) => (
							<a
								key={l.label}
								href={l.href}
								target="_blank"
								rel="noreferrer"
								style={styles.link}
								onMouseEnter={(e) => {
									e.currentTarget.style.background = "var(--coklat)";
									e.currentTarget.style.color = "var(--kuning2)";
									e.currentTarget.style.borderColor = "var(--coklat)";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.background = "white";
									e.currentTarget.style.color = "var(--coklat)";
									e.currentTarget.style.borderColor = "rgba(123,63,0,.15)";
								}}>
								{l.icon} {l.label}
							</a>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}

const styles = {
	section: {
		background: "linear-gradient(135deg, #FFF3D0, #FFF8E8)",
		padding: "6rem 5%",
	},
	wrap: {
		maxWidth: "1080px",
		margin: "0 auto",
		display: "grid",
		gridTemplateColumns: "1.1fr 0.9fr",
		gap: "4rem",
		alignItems: "center",
	},
	lbl: {
		display: "inline-block",
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.28rem 0.95rem",
		borderRadius: "2rem",
		fontSize: "0.72rem",
		fontWeight: 800,
		letterSpacing: "3px",
		textTransform: "uppercase",
	},
	h2: {
		fontFamily: "Lora, serif",
		fontSize: "clamp(1.9rem, 3vw, 2.8rem)",
		fontWeight: 700,
		color: "var(--coklat)",
		margin: "0.8rem 0",
	},
	desc: {
		color: "var(--abu)",
		fontSize: "0.97rem",
		lineHeight: 1.8,
		marginBottom: "1.4rem",
	},
	list: {
		display: "flex",
		flexDirection: "column",
		gap: "0.65rem",
		marginBottom: "1.8rem",
	},
	item: {
		display: "flex",
		alignItems: "flex-start",
		gap: "0.75rem",
		fontSize: "0.9rem",
		color: "var(--gelap)",
		lineHeight: 1.5,
	},
	chk: {
		width: "21px",
		height: "21px",
		minWidth: "21px",
		background: "var(--coklat)",
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "var(--kuning2)",
		fontSize: "0.6rem",
		fontWeight: 800,
		marginTop: "0.15rem",
	},
	btn: {
		display: "inline-block",
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.85rem 2rem",
		borderRadius: "10px",
		fontSize: "0.95rem",
		fontWeight: 700,
		textDecoration: "none",
	},
	targetLabel: {
		fontSize: "0.77rem",
		fontWeight: 700,
		color: "var(--abu)",
		textTransform: "uppercase",
		letterSpacing: "1px",
		marginBottom: "1rem",
	},
	targets: {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: "1rem",
		marginBottom: "1.5rem",
	},

	/* Sapi — coklat bg, angka kuning (sesuai .qt di HTML) */
	targetSapi: {
		background: "var(--coklat)",
		borderRadius: "14px",
		padding: "1.4rem",
		textAlign: "center",
		color: "white",
	},
	targetNumSapi: {
		fontFamily: "Lora, serif",
		fontSize: "2.8rem",
		fontWeight: 700,
		color: "var(--kuning2)",
		lineHeight: 1,
	},
	targetTypeSapi: { fontSize: "0.75rem", opacity: 0.55, marginTop: "0.2rem" },

	/* Domba — kuning bg, angka & teks coklat (sesuai .qt.gold di HTML) */
	targetDomba: {
		background: "var(--kuning)",
		borderRadius: "14px",
		padding: "1.4rem",
		textAlign: "center",
		color: "var(--gelap)",
	},
	targetNumDomba: {
		fontFamily: "Lora, serif",
		fontSize: "2.8rem",
		fontWeight: 700,
		color: "var(--coklat)",
		lineHeight: 1,
	},
	targetTypeDomba: {
		fontSize: "0.75rem",
		opacity: 0.55,
		marginTop: "0.2rem",
		color: "var(--coklat)",
	},

	targetEmoji: { fontSize: "1.9rem", marginBottom: "0.4rem" },
	targetUnit: { fontSize: "0.8rem", opacity: 0.7, marginTop: "0.15rem" },
	links: {
		background: "white",
		borderRadius: "14px",
		padding: "1.3rem",
		border: "1.5px solid rgba(123,63,0,.12)",
	},
	linksTitle: {
		fontSize: "0.8rem",
		fontWeight: 800,
		color: "var(--coklat)",
		textTransform: "uppercase",
		letterSpacing: "1px",
		marginBottom: "0.75rem",
	},
	link: {
		display: "block",
		padding: "0.6rem 0.9rem",
		marginBottom: "0.4rem",
		background: "white",
		border: "1.5px solid rgba(123,63,0,.15)",
		borderRadius: "8px",
		textDecoration: "none",
		color: "var(--coklat)",
		fontSize: "0.84rem",
		fontWeight: 600,
		transition: "all 0.25s",
	},
};
